import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/addOns/catalog/license.addOn.retire.mutation.gql"
import type {
  AddOnRetireMutation,
  AddOnRetireMutationVariables,
} from "@/v2-backoffice-client/license/addOns/catalog/__types__/license.addOn.retire.mutation"

type Options = MutationHookOptions<
  AddOnRetireMutation,
  AddOnRetireMutationVariables
>

export function useAddOnRetireMutation(options?: Options) {
  return useMutation<AddOnRetireMutation, AddOnRetireMutationVariables>(
    mutation,
    options,
  )
}
